module.exports = __webpack_public_path__ + "static/media/aviva.43d90197.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/aviva.png
// module id = 74
// module chunks = 0